// @flow

import React from 'react';
import glamorous from 'glamorous';
import colorUtils from 'color';
import { padding } from 'polished';
import Place from './Place';

type Props = {
  displayCountry: boolean,
  entries: Array<Object>,
};

const WinnersPodiumDiv = glamorous.div(({ theme }) => ({
  backgroundColor: colorUtils(theme.color.panel).alpha(0.5).string(),
  // $FlowIgnore
  ...padding(20, 10, '0'),
}));

const Content = glamorous.div({
  alignItems: 'flex-end',
  display: 'flex',
  justifyContent: 'space-around',
  margin: '0 auto',
  maxWidth: 500,
});

const PodiumWrapper = glamorous.div({
  flexGrow: 1,
  flexShrink: 0,
  flexBasis: 0,
  minWidth: 0, // flexbox hack
});

const Podium = glamorous.div(({ theme }) => ({
  alignItems: 'center',
  backgroundColor: theme.color.panel,
  borderTop: '3px solid #f82859',
  display: 'flex',
  flexDirection: 'row',
  flexGrow: 1,
  flexShrink: 0,
  justifyContent: 'center',
  marginLeft: 4,
  marginRight: 4,
  marginTop: 4,
}), (props) => {
  switch (props.rank) {
    case 1:
      return { height: 60 };
    case 2:
      return { height: 50 };
    default:
      return { height: 40 };
  }
});

const podiums = [2, 1, 3];

function WinnersPodium({
  displayCountry,
  entries,
}: Props) {
  return (
    <WinnersPodiumDiv>
      <Content>
        {podiums.map(position => (
          <PodiumWrapper key={position}>
            <Place
              displayCountry={displayCountry}
              entries={entries.filter(entry => entry.position === position)}
              position={position}
            />
            <Podium rank={position}>
              #{position}
            </Podium>
          </PodiumWrapper>
        ))}
      </Content>
    </WinnersPodiumDiv>
  );
}

export default WinnersPodium;
